<template>
  <div>
    <van-row>
      <van-col style="padding: 10px"
      ><van-tag type="primary" class="title"></van-tag><strong>物流药品订单配送分析</strong></van-col>
    </van-row>
    <van-row>
      <van-col span="12" style="background: rgb(53,179,220);color: white;padding: 10px">
        <div>{{recentData.timelyDeliveryRate}}</div>
        <div>及时配送率({{recentData.date}})</div>
      </van-col>
      <van-col span="12" style="background: rgb(72,122,255);color: white;padding: 10px">
        <div>{{recentData.shortageRate}}</div>
        <div>缺货率({{recentData.date}})</div>
      </van-col>
    </van-row>

    <ve-histogram :data="chartData" :settings="chartSettings" style="margin-top: 20px"></ve-histogram>
  </div>
</template>

<script>
//及时配送率页面
import {spdLogistics} from "@/axios/api";

export default {
  name: "distributionRate",

  created() {
    spdLogistics.getTimeDeliveryRate().then(res => {
      if (res.code === 200) {
        this.chartData.rows = res.result
        this.recentData = res.result[res.result.length-1]
      }
    })
  },

  data() {
    return {
      chartSettings: {
        yAxisType: ['percent'],
        labelMap: {
          'shortage': '缺货率',
          'timelyDelivery': '及时配送率'
        },
        stack:{'total':['timelyDelivery','shortage']},
      },
      chartData: {
        columns: ['date', 'timelyDelivery', 'shortage'],
        rows: [],
      },
      recentData:''
    }
  },

  methods: {}

}
</script>

<style scoped>
.title{
  transform: rotate(90deg);
  font-size: 15px;
  margin-bottom: 2px;
}

</style>



// WEBPACK FOOTER //
// src/spd/logistics/distribution-rate.vue